/**
 * Normalize paginated list API payloads used across admin list pages.
 * Returns { list, total } with list as an array and total as a non-negative number.
 */
export function resolvePaginatedList(payload, { listKeys = [] } = {}) {
  if (payload == null) return { list: [], total: 0 };

  const defaultKeys = [
    "data",
    "items",
    "courses",
    "certs",
    "certificates",
    "records",
    "results",
    "users",
    "sectors",
    "notifications",
    "discounts",
    "bookings",
  ];
  const keys = listKeys.length > 0 ? listKeys : defaultKeys;

  if (Array.isArray(payload)) {
    return { list: payload, total: payload.length };
  }

  if (Array.isArray(payload.data)) {
    return {
      list: payload.data,
      total: readPaginatedTotal(payload) ?? payload.data.length,
    };
  }

  const nested =
    payload.data != null && typeof payload.data === "object" && !Array.isArray(payload.data)
      ? payload.data
      : null;

  if (nested) {
    for (const key of keys) {
      if (Array.isArray(nested[key])) {
        return {
          list: nested[key],
          total: readPaginatedTotal(nested) ?? readPaginatedTotal(payload) ?? nested[key].length,
        };
      }
    }
  }

  for (const key of keys) {
    if (key === "data") continue;
    if (Array.isArray(payload[key])) {
      return {
        list: payload[key],
        total: readPaginatedTotal(payload) ?? payload[key].length,
      };
    }
  }

  return {
    list: [],
    total: readPaginatedTotal(payload) ?? readPaginatedTotal(nested) ?? 0,
  };
}

export function readPaginatedTotal(source) {
  if (source == null || typeof source !== "object") return undefined;
  const n =
    source.totalRecords ??
    source.total ??
    source.results ??
    source.count ??
    source.meta?.total ??
    source.pagination?.total;
  return typeof n === "number" && !Number.isNaN(n) ? n : undefined;
}
